export default "__VITE_ASSET__Bhx_gTOv__"